// import React, { useEffect, useState } from "react";
// import dataService from "../networks/api/service/dataService";
// import {
//   Select,
//   Card,
//   Typography,
//   Descriptions,
//   Spin,
//   Row,
//   Col,
//   Button,
//   Table,
//   message,
// } from "antd";
// import { InfoCircleOutlined } from "@ant-design/icons";
// import CustomTable from "../components/TableComponent/CustomTable";
// const { Option } = Select;

// const { Title, Text } = Typography;

// function ConstituencyDetails() {
//   const [data, setData] = useState([]);
//   const [selectedConstituency, setSelectedConstituency] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [tableTitle, setTableTitle] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [tableColumns, setTableColumns] = useState([]);
//   const [year, setYear] = useState(null);

//   const OnYearSelect = (value) => {
//     setYear(value);
//   };

//   // Fetch constituency details
//   const getConstituency = async () => {
//     try {
//       const res = await dataService.getConstituencyDetails();
//       if (res.code === 200) {
//         setData(res.data);
//         setSelectedConstituency(res.data[0]); // Set first constituency as default
//         setTableTitle(res.data[0]?.constituencyName || ""); // Set initial table title
//       }
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getConstituency();
//   }, []);

//   const generateDynamicTable = (responseData) => {
//     if (responseData.length > 0) {
//       const columns = Object.keys(responseData[0]).map((key) => ({
//         title: key.replace(/([A-Z])/g, " $1").toUpperCase(),
//         dataIndex: key,
//         key: key,
//         render: (text) => {
//           // Apply color scheme for Rank column
//           if (key.toLowerCase() === "rank") {
//             let backgroundColor;
//             if (text === 1) {
//               backgroundColor = "orange";
//             } else if (text === 2) {
//               backgroundColor = "yellow";
//             } else if (text === 3) {
//               backgroundColor = "red";
//             } else {
//               backgroundColor = "transparent";
//             }

//             return (
//               <div
//                 style={{
//                   backgroundColor: backgroundColor,
//                   padding: "10px",
//                   borderRadius: "5px",
//                   textAlign: "center",
//                   color: "black",
//                 }}
//               >
//                 {text}
//               </div>
//             );
//           }

//           // Apply color scheme for percentage column
//           if (key.toLowerCase().includes("%") && typeof text === "number") {
//             let backgroundColor;
//             if (text < 30) {
//               backgroundColor = "red";
//             } else if (text >= 30 && text <= 45) {
//               backgroundColor = "yellow";
//             } else {
//               backgroundColor = "orange";
//             }

//             return (
//               <div
//                 style={{
//                   backgroundColor: backgroundColor,
//                   padding: "10px",
//                   borderRadius: "5px",
//                   textAlign: "center",
//                   color: "black",
//                 }}
//               >
//                 {parseFloat(text).toFixed(2)}%
//               </div>
//             );
//           }

//           // Default rendering for other columns
//           return text;
//         },
//       }));

//       setTableColumns(columns);
//       setTableData(responseData);
//     } else {
//       setTableColumns([]);
//       setTableData([]);
//     }
//   };

//   const getConstituencyDetailsById = async (id) => {
//     try {
//       const response = await dataService.getConstituencyBasedAdminId(id);
//       setSelectedConstituency(response.data);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle constituency selection
//   const handleConstituencySelect = (constituencyId) => {
//     // const constituency = data.find((c) => c._id === constituencyId);
//     // setSelectedConstituency(constituency);
//     getConstituencyDetailsById(constituencyId);
//     setTableData([]);
//     setTableColumns([]);
//     setTableTitle("");
//   };

//   const getElectionDetailsAssembly = async () => {
//     setLoading(true);
//     if (year) {
//       try {
//         const response = await dataService.getConstituencyEDAssembly(
//           selectedConstituency._id,
//           year
//         );
//         setTableTitle(
//           `Constituency Details - ${selectedConstituency.constituencyName}`
//         );
//         generateDynamicTable(response.data);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       message.warning("Select Year");
//       setLoading(false);
//     }
//   };

//   // Fetch and display constituency details in a table
//   const getElectionDetailsConstituency = async () => {
//     setLoading(true);
//     if (year) {
//       try {
//         const response = await dataService.getConstituencyEDConst(
//           selectedConstituency._id,
//           year
//         );
//         setTableTitle(
//           `Constituency Details - ${selectedConstituency.constituencyName}`
//         );
//         generateDynamicTable(response.data);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       message.warning("Select Year");
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: "30px",
//         backgroundColor: "#f7f7f7",
//         minHeight: "100vh",
//       }}
//     >
//       {/* Page Header */}
//       <Row justify="center" style={{ marginBottom: "20px" }}>
//         <Col>
//           <Title level={3}>Parliament Details</Title>
//         </Col>
//       </Row>

//       {/* Constituency Select Dropdown */}
//       <Row
//         justify="center"
//         style={{
//           marginBottom: "20px",
//           // border: "1px solid grey",
//           borderRadius: 5,
//         }}
//       >
//         <Select
//           showSearch
//           optionFilterProp="children"
//           filterOption={(input, option) => {
//             const children = option?.children;
//             return String(children).toLowerCase().includes(input.toLowerCase());
//           }}
//           placeholder="Select a Parliament"
//           style={{
//             width: "100%",
//             maxWidth: "300px",
//             border: "1px solid grey",
//             borderRadius: 5,
//           }}
//           value={selectedConstituency?._id}
//           onChange={handleConstituencySelect}
//           loading={loading}
//         >
//           {data.map((constituency) => (
//             <Select.Option key={constituency._id} value={constituency._id}>
//               {constituency.constituencyName}
//             </Select.Option>
//           ))}
//         </Select>
//       </Row>

//       {/* Display constituency details or loading spinner */}
//       {loading ? (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <Spin size="large" />
//         </div>
//       ) : (
//         selectedConstituency && (
//           <Card
//             style={{
//               marginBottom: "20px",
//               borderRadius: "8px",
//               boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
//             }}
//             title={
//               <span
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   fontSize: "1.4em",
//                   fontWeight: "500",
//                   color: "#595959",
//                 }}
//               >
//                 <InfoCircleOutlined
//                   style={{ marginRight: "10px", color: "#1890ff" }}
//                 />
//                 Parliament Information
//               </span>
//             }
//             bordered
//           >
//             <Descriptions bordered column={1} size="middle">
//               <Descriptions.Item label="Parliament Name">
//                 <Text strong>{selectedConstituency.constituencyName}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Panchayat">
//                 <Text>{selectedConstituency.totalPanchayats}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Assembly">
//                 <Text>{selectedConstituency.totalAssembly}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Booth">
//                 <Text>{selectedConstituency.totalBooths}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Population">
//                 <Text>{selectedConstituency.totalPopulation}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Male Voters">
//                 <Text>{selectedConstituency.totalMaleVoters}</Text>
//               </Descriptions.Item>
//               <Descriptions.Item label="Total Female Voters">
//                 <Text>{selectedConstituency.totalFemaleVoters}</Text>
//               </Descriptions.Item>
//             </Descriptions>
//           </Card>
//         )
//       )}

//       <Row justify="center" gutter={[16, 16]}>
//         {/* <Col>
//           <Button
//             type="primary"
//             onClick={getElectionDetailsAssembly}
//             disabled={!selectedConstituency}
//           >
//             Assembly Details
//           </Button>
//         </Col> */}
//         <Col>
//           <Button
//             type="primary"
//             onClick={getElectionDetailsConstituency}
//             disabled={!selectedConstituency}
//           >
//             Parliament Details
//           </Button>
//         </Col>
//         <Col xs={24} sm={12} md={8}>
//           <Select
//             showSearch
//             optionFilterProp="children"
//             filterOption={(input, option) => {
//               const children = option?.children;
//               return String(children)
//                 .toLowerCase()
//                 .includes(input.toLowerCase());
//             }}
//             placeholder="Select Year"
//             style={{ width: "100%", border: "1px solid grey", borderRadius: 5 }}
//             onChange={OnYearSelect}
//             value={year}
//             disabled={!selectedConstituency}
//           >
//             <Option disabled>Select Year</Option>

//             {[2024, 2019, 2014].map((y) => (
//               <Option key={y} value={y}>
//                 {y}
//               </Option>
//             ))}
//           </Select>
//         </Col>
//       </Row>

//       <div style={{ marginTop: "20px" }}>
//         {tableTitle && (
//           <Title
//             level={4}
//             style={{ marginBottom: "10px", textAlign: "center" }}
//           >
//             {tableTitle}
//           </Title>
//         )}
//         <CustomTable
//           columns={tableColumns}
//           dataSource={tableData}
//           rowKey={(record) => record.key}
//           loading={loading}
//           bordered
//           pagination={true}
//           size="middle"
//           style={{
//             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "8px",
//             backgroundColor: "#fff",
//             width: "100%",
//             overflowX: "auto",
//           }}
//           scroll={{ x: 800 }}
//         />
//       </div>
//     </div>
//   );
// }

// export default ConstituencyDetails;

// import React, { useEffect, useState } from "react";
// import dataService from "../networks/api/service/dataService";
// import AboutComp from "../components/AboutComp";
// import { Breadcrumb, Spin, Table } from "antd";
// const LEVELS = [
//   { key: "assemblyName", title: "Assembly Name" },
//   { key: "blockName", title: "Block Name" },
//   { key: "panchayatName", title: "Panchayat Name" },
//   { key: "boothName", title: "Booth Name" },
//   { key: "villageName", title: "Village Name" },
// ];

// function ConstituencyDetails() {
//   const [constituencyData, setConstituencyData] = useState(null);
//   const adminRoleId = localStorage.getItem("adminRoleId");
//   const [assemblyData, setAssemblyData] = useState([]);
//   const [blockData, setBlockData] = useState([]);
//   const [panchayatData, setPanchayatData] = useState([]);
//   const [boothData, setBoothData] = useState([]);
//   const [villageData, setVillageData] = useState([]);

//   const [currentLevel, setCurrentLevel] = useState(0);
//   const [loadingId, setLoadingId] = useState(null);
//   const [breadcrumb, setBreadcrumb] = useState([]);
//   const getConstituency = async () => {
//     try {
//       const res = await dataService.getAboutConstituency(adminRoleId);
//       if (res.code === 200 && res.data) {
//         setConstituencyData(res.data);
//       }
//     } catch (e) {
//       console.error("Error fetching constituency details:", e);
//     }
//   };

//   const getAboutAssembly = async () => {
//     try {
//       const res = await dataService.aboutAssembly();
//       if (res.code === 200) {
//         setAssemblyData(res.data);
//       }
//     } catch (e) {
//       console.error("Error fetching assembly details:", e);
//     }
//   };

//   useEffect(() => {
//     getAboutAssembly();

//     getConstituency();
//   }, []);

//   const fetchNextLevel = async (id, name, nextLevel) => {
//     if (nextLevel >= LEVELS.length) return;

//     setLoadingId(id);
//     let response;

//     try {
//       if (currentKey === "assemblyName") {
//         response = await dataService.aboutAssemblyBlock(id);
//       } else if (currentKey === "blockName") {
//         response = await dataService.aboutAssemblyPanchayat(id);
//       } else if (currentKey === "panchayatName") {
//         response = await dataService.aboutAssemblyBooth(id);
//       } else if (currentKey === "boothName") {
//         response = await dataService.aboutAssemblyVillage(id);
//       }
//       // if (response.data.length > 0) {
//       setCurrentLevel(nextLevel);
//       setBreadcrumb([...breadcrumb, { name, id }]); // Add clicked level to breadcrumb

//       switch (nextLevel) {
//         case 1:
//           setBlockData(response.data);
//           break;
//         case 2:
//           setPanchayatData(response.data);
//           break;
//         case 3:
//           setBoothData(response.data);
//           break;
//         case 4:
//           setVillageData(response.data);
//           break;
//         default:
//           break;
//       }
//       // }
//     } catch (error) {
//       console.error("Error fetching next level:", error);
//     }
//     setLoadingId(null);
//   };

//   const goBack = (level) => {
//     setCurrentLevel(level);
//     setBreadcrumb(breadcrumb.slice(0, level));

//     switch (level) {
//       case 0:
//         setBlockData([]);
//         setPanchayatData([]);
//         setBoothData([]);
//         setVillageData([]);
//         break;
//       case 1:
//         setPanchayatData([]);
//         setBoothData([]);
//         setVillageData([]);
//         break;
//       case 2:
//         setBoothData([]);
//         setVillageData([]);
//         break;
//       case 3:
//         setVillageData([]);
//         break;
//       default:
//         break;
//     }
//   };

//   const currentKey = LEVELS[currentLevel].key;
//   const currentTitle = LEVELS[currentLevel].title;
//   const currentData =
//     currentLevel === 0
//       ? assemblyData
//       : currentLevel === 1
//       ? blockData
//       : currentLevel === 2
//       ? panchayatData
//       : currentLevel === 3
//       ? boothData
//       : villageData;

//   const columns = [
//     {
//       title: currentTitle,
//       dataIndex: currentKey,
//       key: currentKey,
//       render: (text, record) =>
//         loadingId === record._id ? (
//           <Spin />
//         ) : (
//           <span
//             style={{ cursor: "pointer", color: "blue" }}
//             onClick={() => fetchNextLevel(record._id, text, currentLevel + 1)}
//           >
//             {text}
//           </span>
//         ),
//     },
//   ];

//   return (
//     <>
//       {constituencyData ? (
//         <AboutComp
//           title="Constituency"
//           area={constituencyData.geographicalArea}
//           candidates={constituencyData.electedCandidate}
//         />
//       ) : (
//         <p style={{ textAlign: "center", color: "red" }}>Failed to load data</p>
//       )}
//       <div>
//         {breadcrumb.length > 0 && (
//           <Breadcrumb style={{ marginBottom: 10 }}>
//             <Breadcrumb.Item
//               onClick={() => goBack(0)}
//               style={{ cursor: "pointer" }}
//             >
//               Assembly
//             </Breadcrumb.Item>
//             {breadcrumb.map((item, index) => (
//               <Breadcrumb.Item
//                 key={index}
//                 onClick={() => goBack(index + 1)}
//                 style={{ cursor: "pointer" }}
//               >
//                 {item.name}
//               </Breadcrumb.Item>
//             ))}
//           </Breadcrumb>
//         )}

//         <Table
//           columns={columns}
//           dataSource={currentData}
//           rowKey="_id"
//           pagination={{ pageSize: 5 }}
//         />
//       </div>
//     </>
//   );
// }

// export default ConstituencyDetails;

import React, { useEffect, useState } from "react";
import { Breadcrumb, Spin, Table, Input, Space } from "antd";
import dataService from "../networks/api/service/dataService";
import AboutComp from "../components/AboutComp";

const { Search } = Input;
const LEVELS = [
  { key: "assemblyName", title: "Assembly Name" },
  { key: "blockName", title: "Block Name" },
  { key: "panchayatName", title: "Panchayat Name" },
  { key: "boothName", title: "Booth Name" },
  { key: "villageName", title: "Village Name" },
];

function ConstituencyDetails() {
  const [constituencyData, setConstituencyData] = useState(null);
  const adminRoleId = localStorage.getItem("adminRoleId");
  const [currentLevel, setCurrentLevel] = useState(0);
  const [loadingId, setLoadingId] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [assemblyData, setAssemblyData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [panchayatData, setPanchayatData] = useState([]);
  const [boothData, setBoothData] = useState([]);
  const [villageData, setVillageData] = useState([]);

  useEffect(() => {
    const getConstituency = async () => {
      try {
        const res = await dataService.getAboutConstituency(adminRoleId);
        if (res.code === 200) {
          setConstituencyData(res.data);
        }
      } catch (e) {
        console.error("Error fetching constituency details:", e);
      }
    };

    const getAboutAssembly = async () => {
      try {
        const res = await dataService.aboutAssembly();
        if (res.code === 200) {
          setAssemblyData(res.data);
        }
      } catch (e) {
        console.error("Error fetching assembly details:", e);
      }
    };

    getAboutAssembly();
    getConstituency();
  }, []);

  const fetchNextLevel = async (id, name, nextLevel) => {
    if (nextLevel >= LEVELS.length) return;

    setLoadingId(id);
    let response;

    try {
      const currentKey = LEVELS[currentLevel].key;
      if (currentKey === "assemblyName")
        response = await dataService.aboutAssemblyBlock(id);
      if (currentKey === "blockName")
        response = await dataService.aboutAssemblyPanchayat(id);
      if (currentKey === "panchayatName")
        response = await dataService.aboutAssemblyBooth(id);
      if (currentKey === "boothName")
        response = await dataService.aboutAssemblyVillage(id);

      setCurrentLevel(nextLevel);
      setBreadcrumb([...breadcrumb, { name, id }]);

      switch (nextLevel) {
        case 1:
          setBlockData(response.data);
          break;
        case 2:
          setPanchayatData(response.data);
          break;
        case 3:
          setBoothData(response.data);
          break;
        case 4:
          setVillageData(response.data);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error fetching next level:", error);
    }
    setLoadingId(null);
  };

  const goBack = (level) => {
    setCurrentLevel(level);
    setBreadcrumb(breadcrumb.slice(0, level));
  };

  const currentKey = LEVELS[currentLevel].key;
  const currentTitle = LEVELS[currentLevel].title;
  const currentData = [
    assemblyData,
    blockData,
    panchayatData,
    boothData,
    villageData,
  ][currentLevel];

  const filteredData = currentData.filter((item) =>
    item[currentKey]?.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: currentTitle,
      dataIndex: currentKey,
      key: currentKey,
      render: (text, record) =>
        loadingId === record._id ? (
          <Spin />
        ) : (
          <span
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => fetchNextLevel(record._id, text, currentLevel + 1)}
          >
            {text}
          </span>
        ),
    },
  ];

  return (
    <div>
      {constituencyData ? (
        <AboutComp
          title="Constituency"
          area={constituencyData.geographicalArea}
          candidates={constituencyData.electedCandidate}
          mapImage={constituencyData?.map}
        />
      ) : (
        <p style={{ textAlign: "center", color: "red" }}>Failed to load data</p>
      )}
      <div style={{ padding: 20, maxWidth: 500, margin: "auto" }}>
        {breadcrumb.length > 0 && (
          <Breadcrumb style={{ marginBottom: 10 }}>
            <Breadcrumb.Item
              onClick={() => goBack(0)}
              style={{ cursor: "pointer" }}
            >
              Assembly
            </Breadcrumb.Item>
            {breadcrumb.map((item, index) => (
              <Breadcrumb.Item
                key={index}
                onClick={() => goBack(index + 1)}
                style={{ cursor: "pointer" }}
              >
                {item.name}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}

        <Space
          style={{
            marginBottom: 10,
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <Search
            placeholder={`Search ${currentTitle}`}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
          />
        </Space>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="_id"
          pagination={{ pageSize: 5 }}
        />
      </div>
    </div>
  );
}

export default ConstituencyDetails;
